/* eslint-disable @typescript-eslint/naming-convention */
import { useContext } from 'react'
import { MapDataContext } from 'src/store/map/Store'
import { StatsDataContext } from 'src/store/stats/Store'

const useLightValue = () => {
  const { map } = useContext(MapDataContext)
  const { stats } = useContext(StatsDataContext)
  const { player_x, player_y } = map.counters
  const { light_radius } = stats.total

  return {light_radius, player_x, player_y}
}

export default useLightValue
